import { useState, useEffect, useRef } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";

import { Container, Row, Col, Form, InputGroup } from "react-bootstrap";

import api from "../../services/api";

import * as S from "./styled";

import Template from "../../template";
import { useAuth } from "../../context/auth";
import MiniaturaFoto from "../../components/FotoUsuario/Miniatura";

/*
  Os filtros vivem também na query string.

  Antes ficavam só em useState: ao abrir uma correção e voltar, a listagem
  remontava zerada e o professor tinha que refazer a busca inteira. Com os
  filtros na URL o "Voltar" devolve exatamente a lista que ele tinha montado.
*/
const FILTRO_PADRAO = "2";
const ITENS_POR_PAGINA_PADRAO = 50;

function lerFiltrosDaUrl(search) {
  const q = new URLSearchParams(search);
  const pagina = parseInt(q.get("pagina"), 10);
  const porPagina = parseInt(q.get("porPagina"), 10);

  return {
    status: q.get("status") || FILTRO_PADRAO,
    aluno: q.get("aluno") || "",
    tema: q.get("tema") || "",
    turma: q.get("turma") || "",
    corretor: q.get("corretor") || "",
    dataInicio: q.get("de") || "",
    dataFim: q.get("ate") || "",
    correcaoInicio: q.get("cde") || "",
    correcaoFim: q.get("cate") || "",
    pagina: Number.isFinite(pagina) && pagina > 0 ? pagina : 1,
    porPagina: Number.isFinite(porPagina) && porPagina > 0 ? porPagina : ITENS_POR_PAGINA_PADRAO,
  };
}

/*
  "2026-10-09" -> "09/10/2026", sem passar por Date.

  `new Date("2026-10-09")` é lido como meia-noite UTC e, exibido no horário de
  Brasília, volta um dia: o selo mostrava 08/10 para quem escolheu 09/10. O valor
  enviado ao backend sempre esteve certo; o engano era só na tela.
*/
function dataBR(iso) {
  if (!iso) return "";

  const [ano, mes, dia] = String(iso).slice(0, 10).split("-");

  return ano && mes && dia ? `${dia}/${mes}/${ano}` : iso;
}

function montarQueryDeFiltros(f) {
  const q = new URLSearchParams();

  // só entra na URL o que difere do padrão, para o link não virar um paredão
  if (f.status !== FILTRO_PADRAO) q.set("status", f.status);
  if (f.aluno) q.set("aluno", f.aluno);
  if (f.tema) q.set("tema", f.tema);
  if (f.turma) q.set("turma", f.turma);
  if (f.corretor) q.set("corretor", f.corretor);
  if (f.dataInicio) q.set("de", f.dataInicio);
  if (f.dataFim) q.set("ate", f.dataFim);
  if (f.correcaoInicio) q.set("cde", f.correcaoInicio);
  if (f.correcaoFim) q.set("cate", f.correcaoFim);
  if (f.pagina > 1) q.set("pagina", String(f.pagina));
  if (f.porPagina !== ITENS_POR_PAGINA_PADRAO) q.set("porPagina", String(f.porPagina));

  const s = q.toString();
  return s ? `?${s}` : "";
}

function Redacoes() {
  const location = useLocation();
  // lido uma única vez na montagem: depois quem manda é o state
  const [filtrosIniciais] = useState(() => lerFiltrosDaUrl(location.search));

  const [loading, setLoading] = useState(true);

  const [redacoes, setRedacoes] = useState([]);
  const [temas, setTemas] = useState([]);
  const [turmas, setTurmas] = useState([]);
  const [corretores, setCorretores] = useState([]);

  const [filtro, setFiltro] = useState(filtrosIniciais.status);

  const [buscaTema, setBuscaTema] = useState("");
  const [buscaTurma, setBuscaTurma] = useState("");
  // o input do aluno é texto livre com debounce; restaura o texto e o valor aplicado
  const [buscaAluno, setBuscaAluno] = useState(filtrosIniciais.aluno);
  const [buscaCorretor, setBuscaCorretor] = useState("");

  const [dataInicio, setDataInicio] = useState(filtrosIniciais.dataInicio);
  const [dataFim, setDataFim] = useState(filtrosIniciais.dataFim);

  /* datas da correção: pergunta diferente da data de envio, filtro separado */
  const [correcaoInicio, setCorrecaoInicio] = useState(filtrosIniciais.correcaoInicio);
  const [correcaoFim, setCorrecaoFim] = useState(filtrosIniciais.correcaoFim);

  const [showDropdownTema, setShowDropdownTema] = useState(false);
  const [showDropdownTurma, setShowDropdownTurma] = useState(false);
  const [showDropdownCorretor, setShowDropdownCorretor] = useState(false);

  const [alunoSelecionado, setAlunoSelecionado] = useState(filtrosIniciais.aluno);
  const [temaSelecionado, setTemaSelecionado] = useState(filtrosIniciais.tema);
  const [turmaSelecionada, setTurmaSelecionada] = useState(filtrosIniciais.turma);
  const [corretorSelecionado, setCorretorSelecionado] = useState(filtrosIniciais.corretor);

  const [itensPorPaginaDropdownAberto, setItensPorPaginaDropdownAberto] = useState(false);
  const [statusDropdownAberto, setStatusDropdownAberto] = useState(false);

  const [paginaAtual, setPaginaAtual] = useState(filtrosIniciais.pagina);
  const [itensPorPagina, setItensPorPagina] = useState(filtrosIniciais.porPagina);
  const [totalItens, setTotalItens] = useState(0);
  const [totalPaginas, setTotalPaginas] = useState(0);

  const history = useHistory();

  const user = useAuth();

  if(user.user.nivel === "e") {
    history.push("/classe");
  }

  

  const mapStatusToAPI = (filtroValue) => {
    if (filtroValue === "2") return "todas_redacoes";
    if (filtroValue === "1") return "corrigido";
    if (filtroValue === "0") return "pendente_correcao";
    if (filtroValue === "3") return "envio_pendente_aluno";
    /* 4: alguém já marcou a redação e ainda não finalizou */
    if (filtroValue === "4") return "em_correcao";
    return "todas_redacoes";
  };

  const getRedacoes = async (signal) => {
    try {
      const params = { page: paginaAtual, limit: itensPorPagina, status: mapStatusToAPI(filtro) };
      if (dataInicio) params.dataInicio = dataInicio;
      if (dataFim) params.dataFim = dataFim;
      if (correcaoInicio) params.correcaoInicio = correcaoInicio;
      if (correcaoFim) params.correcaoFim = correcaoFim;
      if (alunoSelecionado) params.aluno = alunoSelecionado;
      if (temaSelecionado) params.tema = temaSelecionado;
      if (turmaSelecionada) params.turma = turmaSelecionada;
      if (corretorSelecionado) params.corretor = corretorSelecionado;

      const response = await api.get('/correcoes', { params, signal });
      if (!signal.aborted) {
        setRedacoes(response.data.data);
        setTotalItens(response.data.paginacao.totalCount);
        setTotalPaginas(response.data.paginacao.totalPages);
      }
    } catch (err) {
      if (!signal.aborted) {
        console.error('Erro ao carregar redações:', err);
      }
    } finally {
      if (!signal.aborted) {
        setLoading(false);
      }
    }
  };

  const getTemas = async (signal) => {
    try {
      let response = await api.get(`/pegarTemasGeral`, {
        signal: signal
      });
      if (!signal.aborted) {
        setTemas(response.data);
      }
    } catch (err) {
      if (!signal.aborted) {
        console.error('Erro ao carregar temas:', err);
      }
    } finally {
      if (!signal.aborted) {
        setLoading(false);
      }
    }
  };

  const getTurmas = async (signal) => {
    try {
      let response = await api.get("/classes", {
        signal: signal
      });
      if (!signal.aborted) {
        setTurmas(response.data);
      }
    } catch (err) {
      if (!signal.aborted) {
        console.error('Erro ao carregar turmas:', err);
      }
    } finally {
      if (!signal.aborted) {
        setLoading(false);
      }
    }
  };

  const getCorretores = async (signal) => {
    try {
      let response = await api.get("/getCorretores", {
        signal: signal
      });
      if (!signal.aborted) {
        setCorretores(response.data);
      }
    } catch (err) {
      if (!signal.aborted) {
        console.error('Erro ao carregar corretores:', err);
      }
    }
  };

  /*
    Espelha os filtros na URL. `replace` e não `push`: cada tecla digitada num
    filtro não pode virar uma entrada no histórico, senão o botão voltar do
    navegador ficaria preso desfazendo filtro por filtro.
  */
  const queryDosFiltros = montarQueryDeFiltros({
    status: filtro,
    aluno: alunoSelecionado,
    tema: temaSelecionado,
    turma: turmaSelecionada,
    corretor: corretorSelecionado,
    dataInicio,
    dataFim,
    correcaoInicio,
    correcaoFim,
    pagina: paginaAtual,
    porPagina: itensPorPagina,
  });

  useEffect(() => {
    if (queryDosFiltros !== location.search) {
      history.replace(`${location.pathname}${queryDosFiltros}`);
    }
  }, [queryDosFiltros, location.pathname, location.search, history]);

  // leva a lista filtrada junto, para o "Voltar" da correção devolver exatamente ela
  const destinoCorrecao = (idRedacao) => ({
    pathname: `/corrigir/redacao/${idRedacao}`,
    state: { voltarPara: `${location.pathname}${queryDosFiltros}` },
  });

  // Filtrar temas/turmas/corretores localmente para sugestões dos dropdowns
  const temasFiltrados = buscaTema.length > 0
    ? temas.filter(tema => {
        if (!tema || !tema.genero || !tema.aula || !tema.nome) return false;
        return `${tema.genero} ${tema.aula} - ${tema.nome}`.toLowerCase().includes(buscaTema.toLowerCase());
      }).sort((a, b) => `${a.genero} ${a.aula} - ${a.nome}`.localeCompare(`${b.genero} ${b.aula} - ${b.nome}`))
    : temas.filter(t => t && t.genero && t.aula && t.nome).sort((a, b) => `${a.genero} ${a.aula} - ${a.nome}`.localeCompare(`${b.genero} ${b.aula} - ${b.nome}`));

  const turmasFiltradas = buscaTurma.length > 0
    ? turmas.filter(t => t && t.name && t.name.toLowerCase().includes(buscaTurma.toLowerCase()))
    : turmas.filter(t => t && t.name).sort((a, b) => a.name.localeCompare(b.name));

  const corretoresFiltrados = buscaCorretor.length > 0
    ? corretores.filter(c => c && c.name && c.name.toLowerCase().includes(buscaCorretor.toLowerCase()))
    : corretores.filter(c => c && c.name).sort((a, b) => a.name.localeCompare(b.name));

  const selecionarTema = (tema) => {
    setTemaSelecionado(tema.nome);
    setBuscaTema("");
    setShowDropdownTema(false);
    setPaginaAtual(1);
  };

  const selecionarTurma = (turma) => {
    setTurmaSelecionada(turma.name);
    setBuscaTurma("");
    setShowDropdownTurma(false);
    setPaginaAtual(1);
  };

  const selecionarCorretor = (corretor) => {
    setCorretorSelecionado(corretor.name);
    setBuscaCorretor("");
    setShowDropdownCorretor(false);
    setPaginaAtual(1);
  };

  const irParaPagina = (pagina) => setPaginaAtual(pagina);
  const paginaAnterior = () => { if (paginaAtual > 1) setPaginaAtual(paginaAtual - 1); };
  const proximaPagina = () => { if (paginaAtual < totalPaginas) setPaginaAtual(paginaAtual + 1); };

  const limparFiltros = () => {
    setFiltro("2");
    setBuscaTema("");
    setBuscaTurma("");
    setBuscaAluno("");
    setBuscaCorretor("");
    setAlunoSelecionado("");
    setTemaSelecionado("");
    setTurmaSelecionada("");
    setCorretorSelecionado("");
    setDataInicio("");
    setCorrecaoInicio("");
    setCorrecaoFim("");
    setDataFim("");
    setShowDropdownTema(false);
    setShowDropdownTurma(false);
    setShowDropdownCorretor(false);
    setPaginaAtual(1);
  };

  // Debounce do campo aluno: 500ms após parar de digitar
  const primeiroRenderAluno = useRef(true);

  useEffect(() => {
    /*
      Pula a primeira execução: na montagem `buscaAluno` já veio da URL e não é
      digitação do usuário — deixar passar zeraria a página restaurada (?pagina=3).
    */
    if (primeiroRenderAluno.current) {
      primeiroRenderAluno.current = false;
      return;
    }

    const timer = setTimeout(() => {
      setAlunoSelecionado(buscaAluno);
      setPaginaAtual(1);
    }, 500);
    return () => clearTimeout(timer);
  }, [buscaAluno]);

  useEffect(() => {
    const controller = new AbortController();
    getTemas(controller.signal);
    getTurmas(controller.signal);
    getCorretores(controller.signal);
    return () => controller.abort();
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    getRedacoes(controller.signal);
    return () => controller.abort();
  }, [filtro, alunoSelecionado, temaSelecionado, turmaSelecionada, corretorSelecionado, dataInicio, dataFim, correcaoInicio, correcaoFim, paginaAtual, itensPorPagina]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-container')) {
        setShowDropdownTema(false);
        setShowDropdownTurma(false);
        setShowDropdownCorretor(false);
        setItensPorPaginaDropdownAberto(false);
        setStatusDropdownAberto(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <Template>
      <S.MainWrapper>
        <Container fluid>
          <Row>
            <Col sm={12}>
              <S.MainContent>
                {/* Cabeçalho da página */}
                <Row>
                  <Col sm={12}>
                    <div className="shadow-sm p-4 mb-4 bg-white rounded">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <i className="fas fa-edit text-primary mr-3" style={{fontSize: '2rem'}}></i>
                          <div>
                            <h3 className="mb-0 text-dark font-weight-bold">Correção - Redações</h3>
                            <p className="mb-0 text-muted">Gerencie e corrija as redações dos alunos</p>
                          </div>
                        </div>
                        <div className="text-center">
                          <div className="display-4 text-primary font-weight-bold">
                            {totalItens}
                          </div>
                          <small className="text-muted font-weight-bold">
                            {totalItens === 1 ? 'redação encontrada' : 'redações encontradas'}
                          </small>
                          {totalItens > 0 && (
                            <div className="mt-2">
                              <small className="text-info font-weight-bold">
                                Página {paginaAtual} de {totalPaginas} |
                                Mostrando {(paginaAtual - 1) * itensPorPagina + 1}-{Math.min(paginaAtual * itensPorPagina, totalItens)} de {totalItens}
                              </small>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>

                {/* Seção de Filtros Melhorada */}
                <Row className="mb-4">
                  <Col sm={12}>
                    <div className="card border-0 shadow-sm">
                      <div className="card-header bg-light border-0">
                        <div className="d-flex align-items-center justify-content-between">
                          <h5 className="mb-0 text-dark font-weight-bold">
                            <i className="fas fa-filter text-primary mr-2"></i>
                            Filtros de Busca
                          </h5>
                          <button 
                            className="btn btn-outline-secondary btn-sm"
                            onClick={limparFiltros}
                          >
                            <i className="fas fa-times mr-1"></i>
                            Limpar Filtros
                          </button>
                        </div>
                      </div>
                      <div className="card-body" style={{ overflow: 'visible' }}>
                        <Row>
                          {/* Controle de Itens por Página */}
                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group className="dropdown-container" style={{ position: 'relative' }}>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-list text-primary mr-1"></i>
                                Itens por Página
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-list"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="text"
                                  value={`${itensPorPagina} por página`}
                                  onClick={() => {
                                    setItensPorPaginaDropdownAberto(!itensPorPaginaDropdownAberto);
                                    setStatusDropdownAberto(false);
                                    setShowDropdownTema(false);
                                    setShowDropdownTurma(false);
                                    setShowDropdownCorretor(false);
                                  }}
                                  readOnly
                                  className="form-control-lg"
                                  style={{ cursor: 'pointer', backgroundColor: 'white' }}
                                />
                              </InputGroup>
                              {itensPorPaginaDropdownAberto && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    backgroundColor: 'white',
                                    border: '1px solid #ced4da',
                                    borderTop: 'none',
                                    borderRadius: '0 0 0.25rem 0.25rem',
                                    maxHeight: '400px',
                                    overflowY: 'auto',
                                    zIndex: 9999,
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    marginTop: '-1px'
                                  }}
                                >
                                  {[25, 50, 100, 200].map((valor) => (
                                    <div
                                      key={valor}
                                      onClick={() => {
                                        setItensPorPagina(valor);
                                        setPaginaAtual(1);
                                        setItensPorPaginaDropdownAberto(false);
                                      }}
                                      style={{
                                        padding: '8px 12px',
                                        cursor: 'pointer',
                                        backgroundColor: itensPorPagina === valor ? '#007bff' : 'white',
                                        color: itensPorPagina === valor ? 'white' : 'black'
                                      }}
                                      onMouseEnter={(e) => {
                                        if (itensPorPagina !== valor) {
                                          e.target.style.backgroundColor = '#f8f9fa';
                                        }
                                      }}
                                      onMouseLeave={(e) => {
                                        if (itensPorPagina !== valor) {
                                          e.target.style.backgroundColor = 'white';
                                        }
                                      }}
                                    >
                                      {valor} por página
                                    </div>
                                  ))}
                                </div>
                              )}
                            </Form.Group>
                          </Col>

                          {/* Filtro por Status */}
                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group className="dropdown-container" style={{ position: 'relative' }}>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-info-circle text-primary mr-1"></i>
                                Status
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-flag"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="text"
                                  value={filtro === "2" ? "Todas as Redações" : filtro === "1" ? "Corrigidas" : filtro === "0" ? "Aguardando Correção" : filtro === "4" ? "Em correção" : "Envio Pendente do Aluno"}
                                  onClick={() => {
                                    setStatusDropdownAberto(!statusDropdownAberto);
                                    setItensPorPaginaDropdownAberto(false);
                                    setShowDropdownTema(false);
                                    setShowDropdownTurma(false);
                                    setShowDropdownCorretor(false);
                                  }}
                                  readOnly
                                  className="form-control-lg"
                                  style={{ cursor: 'pointer', backgroundColor: 'white' }}
                                />
                              </InputGroup>
                              {statusDropdownAberto && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    backgroundColor: 'white',
                                    border: '1px solid #ced4da',
                                    borderTop: 'none',
                                    borderRadius: '0 0 0.25rem 0.25rem',
                                    maxHeight: '400px',
                                    overflowY: 'auto',
                                    zIndex: 9999,
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    marginTop: '-1px'
                                  }}
                                >
                                  {[
                                    { valor: "2", texto: "Todas as Redações" },
                                    { valor: "1", texto: "Corrigidas" },
                                    { valor: "0", texto: "Aguardando Correção" },
                                    { valor: "4", texto: "Em correção" },
                                    { valor: "3", texto: "Envio Pendente do Aluno" }
                                  ].map((opcao) => (
                                    <div
                                      key={opcao.valor}
                                      onClick={() => {
                                        setFiltro(opcao.valor);
                                        setPaginaAtual(1);
                                        setStatusDropdownAberto(false);
                                      }}
                                      style={{
                                        padding: '8px 12px',
                                        cursor: 'pointer',
                                        backgroundColor: filtro === opcao.valor ? '#007bff' : 'white',
                                        color: filtro === opcao.valor ? 'white' : 'black'
                                      }}
                                      onMouseEnter={(e) => {
                                        if (filtro !== opcao.valor) {
                                          e.target.style.backgroundColor = '#f8f9fa';
                                        }
                                      }}
                                      onMouseLeave={(e) => {
                                        if (filtro !== opcao.valor) {
                                          e.target.style.backgroundColor = 'white';
                                        }
                                      }}
                                    >
                                      {opcao.texto}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </Form.Group>
                          </Col>

                          {/* Busca por Aluno */}
                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-user text-primary mr-1"></i>
                                Buscar Aluno
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-search"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="text"
                                  placeholder="Digite o nome do aluno..."
                                  value={buscaAluno}
                                  onChange={(e) => setBuscaAluno(e.target.value)}
                                  className="form-control-lg"
                                />
                                {buscaAluno && (
                                  <InputGroup.Append>
                                    <button
                                      className="btn btn-outline-secondary"
                                      type="button"
                                      onClick={() => { setBuscaAluno(""); setAlunoSelecionado(""); setPaginaAtual(1); }}
                                    >×</button>
                                  </InputGroup.Append>
                                )}
                              </InputGroup>
                            </Form.Group>
                          </Col>

                          {/* Filtro por Tema com busca */}
                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group className="dropdown-container">
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-book text-primary mr-1"></i>
                                Tema
                              </Form.Label>
                              <div style={{ position: 'relative' }}>
                                <InputGroup className="mb-2">
                                  <InputGroup.Prepend>
                                    <InputGroup.Text>
                                      <i className="fas fa-search"></i>
                                    </InputGroup.Text>
                                  </InputGroup.Prepend>
                                  <Form.Control
                                    type="text"
                                    placeholder="Buscar tema..."
                                    value={buscaTema}
                                    onChange={(e) => {
                                       setBuscaTema(e.target.value);
                                       setShowDropdownTema(true);
                                       setItensPorPaginaDropdownAberto(false);
                                       setStatusDropdownAberto(false);
                                     }}
                                     onFocus={() => {
                                       setShowDropdownTema(true);
                                       setItensPorPaginaDropdownAberto(false);
                                       setStatusDropdownAberto(false);
                                     }}
                                     onBlur={() => setTimeout(() => setShowDropdownTema(false), 200)}
                                     className="form-control-lg"
                                  />
                                </InputGroup>
                                {temaSelecionado && (
                                  <div className="mt-1">
                                    <span className="badge badge-success" style={{ whiteSpace: 'normal', textAlign: 'left', display: 'inline-block', maxWidth: '100%', lineHeight: 1.4 }}>
                                      {temaSelecionado}
                                      <button 
                                        type="button" 
                                        className="btn btn-sm btn-link text-white p-0 ml-2" 
                                        style={{ fontSize: '0.7em' }}
                                        onClick={() => {
                                          setTemaSelecionado("");
                                          setPaginaAtual(1);
                                        }}
                                      >
                                        ×
                                      </button>
                                    </span>
                                  </div>
                                )}
                                {showDropdownTema && temasFiltrados.length > 0 && (
                                  <div 
                                    style={{
                                      position: 'absolute',
                                      top: '100%',
                                      left: 0,
                                      right: 0,
                                      backgroundColor: 'white',
                                      border: '1px solid #ced4da',
                                      borderTop: 'none',
                                      borderRadius: '0 0 0.375rem 0.375rem',
                                      maxHeight: '400px',
                                      overflowY: 'auto',
                                      zIndex: 9999,
                                      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                                      marginTop: '-1px'
                                    }}
                                  >
                                    {temasFiltrados.map((tema, index) => (
                                      <div
                                        key={index}
                                        style={{
                                          padding: '8px 12px',
                                          cursor: 'pointer',
                                          borderBottom: index < temasFiltrados.length - 1 ? '1px solid #eee' : 'none'
                                        }}
                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                        onClick={() => selecionarTema(tema)}
                                      >
                                        {tema.genero} {tema.aula} - {tema.nome}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>

                            </Form.Group>
                          </Col>

                          {/* Filtro por Turma com busca */}
                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group className="dropdown-container">
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-users text-primary mr-1"></i>
                                Turma
                              </Form.Label>
                              <div style={{ position: 'relative' }}>
                                <InputGroup className="mb-2">
                                  <InputGroup.Prepend>
                                    <InputGroup.Text>
                                      <i className="fas fa-search"></i>
                                    </InputGroup.Text>
                                  </InputGroup.Prepend>
                                  <Form.Control
                                    type="text"
                                    placeholder="Buscar turma..."
                                    value={buscaTurma}
                                    onChange={(e) => {
                                       setBuscaTurma(e.target.value);
                                       setShowDropdownTurma(true);
                                       setItensPorPaginaDropdownAberto(false);
                                       setStatusDropdownAberto(false);
                                     }}
                                     onFocus={() => {
                                       setShowDropdownTurma(true);
                                       setItensPorPaginaDropdownAberto(false);
                                       setStatusDropdownAberto(false);
                                     }}
                                     onBlur={() => setTimeout(() => setShowDropdownTurma(false), 200)}
                                     className="form-control-lg"
                                  />
                                </InputGroup>
                                {turmaSelecionada && (
                                  <div className="mt-1">
                                    <span className="badge badge-info" style={{ whiteSpace: 'normal', textAlign: 'left', display: 'inline-block', maxWidth: '100%', lineHeight: 1.4 }}>
                                      {turmaSelecionada}
                                      <button 
                                        type="button" 
                                        className="btn btn-sm btn-link text-white p-0 ml-2" 
                                        style={{ fontSize: '0.7em' }}
                                        onClick={() => {
                                          setTurmaSelecionada("");
                                          setPaginaAtual(1);
                                        }}
                                      >
                                        ×
                                      </button>
                                    </span>
                                  </div>
                                )}
                                {showDropdownTurma && turmasFiltradas.length > 0 && (
                                  <div 
                                    style={{
                                      position: 'absolute',
                                      top: '100%',
                                      left: 0,
                                      right: 0,
                                      backgroundColor: 'white',
                                      border: '1px solid #ced4da',
                                      borderTop: 'none',
                                      borderRadius: '0 0 0.375rem 0.375rem',
                                      maxHeight: '400px',
                                      overflowY: 'auto',
                                      zIndex: 9999,
                                      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                                      marginTop: '-1px'
                                    }}
                                  >
                                    {turmasFiltradas.map((turma, index) => (
                                      <div
                                        key={index}
                                        style={{
                                          padding: '8px 12px',
                                          cursor: 'pointer',
                                          borderBottom: index < turmasFiltradas.length - 1 ? '1px solid #eee' : 'none'
                                        }}
                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                        onClick={() => selecionarTurma(turma)}
                                      >
                                        {turma.name}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>

                            </Form.Group>
                          </Col>

                          {/* Filtro por Corretor com busca */}
                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group className="dropdown-container">
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-user-check text-primary mr-1"></i>
                                Corretor
                              </Form.Label>
                              <div style={{ position: 'relative' }}>
                                <InputGroup className="mb-2">
                                  <InputGroup.Prepend>
                                    <InputGroup.Text>
                                      <i className="fas fa-search"></i>
                                    </InputGroup.Text>
                                  </InputGroup.Prepend>
                                  <Form.Control
                                    type="text"
                                    placeholder="Buscar corretor..."
                                    value={buscaCorretor}
                                    onChange={(e) => {
                                       setBuscaCorretor(e.target.value);
                                       setShowDropdownCorretor(true);
                                       setItensPorPaginaDropdownAberto(false);
                                       setStatusDropdownAberto(false);
                                     }}
                                     onFocus={() => {
                                       setShowDropdownCorretor(true);
                                       setItensPorPaginaDropdownAberto(false);
                                       setStatusDropdownAberto(false);
                                     }}
                                     onBlur={() => setTimeout(() => setShowDropdownCorretor(false), 200)}
                                     className="form-control-lg"
                                  />
                                </InputGroup>
                                {corretorSelecionado && (
                                  <div className="mt-1">
                                    <span className="badge badge-warning" style={{ whiteSpace: 'normal', textAlign: 'left', display: 'inline-block', maxWidth: '100%', lineHeight: 1.4 }}>
                                      {corretorSelecionado}
                                      <button 
                                        type="button" 
                                        className="btn btn-sm btn-link text-white p-0 ml-2" 
                                        style={{ fontSize: '0.7em' }}
                                        onClick={() => {
                                          setCorretorSelecionado("");
                                          setPaginaAtual(1);
                                        }}
                                      >
                                        ×
                                      </button>
                                    </span>
                                  </div>
                                )}
                                {showDropdownCorretor && corretoresFiltrados.length > 0 && (
                                  <div 
                                    style={{
                                      position: 'absolute',
                                      top: '100%',
                                      left: 0,
                                      right: 0,
                                      backgroundColor: 'white',
                                      border: '1px solid #ced4da',
                                      borderTop: 'none',
                                      borderRadius: '0 0 0.375rem 0.375rem',
                                      maxHeight: '400px',
                                      overflowY: 'auto',
                                      zIndex: 9999,
                                      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                                      marginTop: '-1px'
                                    }}
                                  >
                                    {corretoresFiltrados.map((corretor, index) => (
                                      <div
                                        key={index}
                                        style={{
                                          padding: '8px 12px',
                                          cursor: 'pointer',
                                          borderBottom: index < corretoresFiltrados.length - 1 ? '1px solid #eee' : 'none'
                                        }}
                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                        onClick={() => selecionarCorretor(corretor)}
                                      >
                                        {corretor.name}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                        
                        {/* Segunda linha de filtros - Filtros por Data */}
                        <Row>
                          {/* Filtro por Data de Início */}
                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-calendar-alt text-primary mr-1"></i>
                                Enviada a partir de
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-calendar"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="date"
                                  value={dataInicio}
                                  onChange={(e) => {
                                    setDataInicio(e.target.value);
                                    setPaginaAtual(1);
                                  }}
                                  className="form-control-lg"
                                />
                              </InputGroup>
                              {dataInicio && (
                                <div className="mt-1">
                                  <span className="badge badge-secondary">
                                    Desde: {dataBR(dataInicio)}
                                    <button 
                                      type="button" 
                                      className="btn btn-sm btn-link text-white p-0 ml-2" 
                                      style={{ fontSize: '0.7em' }}
                                      onClick={() => {
                                        setDataInicio("");
                                        setPaginaAtual(1);
                                      }}
                                    >
                                      ×
                                    </button>
                                  </span>
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          
                          {/* Filtro por Data de Fim */}
                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-calendar-alt text-primary mr-1"></i>
                                Enviada até
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-calendar"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="date"
                                  value={dataFim}
                                  onChange={(e) => {
                                    setDataFim(e.target.value);
                                    setPaginaAtual(1);
                                  }}
                                  className="form-control-lg"
                                />
                              </InputGroup>
                              {dataFim && (
                                <div className="mt-1">
                                  <span className="badge badge-secondary">
                                    Até: {dataBR(dataFim)}
                                    <button 
                                      type="button" 
                                      className="btn btn-sm btn-link text-white p-0 ml-2" 
                                      style={{ fontSize: '0.7em' }}
                                      onClick={() => {
                                        setDataFim("");
                                        setPaginaAtual(1);
                                      }}
                                    >
                                      ×
                                    </button>
                                  </span>
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          
                          {/*
                            Datas da correção, separadas das de envio. Antes só havia
                            o par de cima, e filtrar por ele para medir produtividade
                            respondia outra pergunta: "enviadas no período", não
                            "corrigidas no período".
                          */}
                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-check-double text-success mr-1"></i>
                                Corrigida a partir de
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-calendar-check"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="date"
                                  value={correcaoInicio}
                                  onChange={(e) => {
                                    setCorrecaoInicio(e.target.value);
                                    setPaginaAtual(1);
                                  }}
                                  className="form-control-lg"
                                />
                              </InputGroup>
                              {correcaoInicio && (
                                <div className="mt-1">
                                  <span className="badge badge-success">
                                    Desde: {dataBR(correcaoInicio)}
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-link text-white p-0 ml-2"
                                      style={{ fontSize: '0.7em' }}
                                      onClick={() => {
                                        setCorrecaoInicio("");
                                        setPaginaAtual(1);
                                      }}
                                    >
                                      ×
                                    </button>
                                  </span>
                                </div>
                              )}
                            </Form.Group>
                          </Col>

                          <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                            <Form.Group>
                              <Form.Label className="font-weight-bold text-dark">
                                <i className="fas fa-check-double text-success mr-1"></i>
                                Corrigida até
                              </Form.Label>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-calendar-check"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="date"
                                  value={correcaoFim}
                                  onChange={(e) => {
                                    setCorrecaoFim(e.target.value);
                                    setPaginaAtual(1);
                                  }}
                                  className="form-control-lg"
                                />
                              </InputGroup>
                              {correcaoFim && (
                                <div className="mt-1">
                                  <span className="badge badge-success">
                                    Até: {dataBR(correcaoFim)}
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-link text-white p-0 ml-2"
                                      style={{ fontSize: '0.7em' }}
                                      onClick={() => {
                                        setCorrecaoFim("");
                                        setPaginaAtual(1);
                                      }}
                                    >
                                      ×
                                    </button>
                                  </span>
                                </div>
                              )}
                            </Form.Group>
                          </Col>

                          <Col xs={12} className="mb-3">
                            <div className="d-flex align-items-end h-100">
                              <small className="text-muted">
                                <i className="fas fa-info-circle mr-1"></i>
                                As duas primeiras datas filtram por <strong>envio do aluno</strong>;
                                as duas de baixo, por <strong>quando a correção foi feita</strong>.
                                Para medir produção de corretor, use as de baixo.
                              </small>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
                {loading ? (
                  <>
                    <Col className="text-center">
                      <div className="shadow p-3 mb-4 bg-white rounded fdark flex-c">
                        <div>
                          <div className="spinner-grow text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                          <div
                            className="spinner-grow text-secondary"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                          <div className="spinner-grow text-success" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                          <div className="spinner-grow text-danger" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                          <div className="spinner-grow text-warning" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                          <div className="spinner-grow text-info" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                        <div>
                          <strong>CARREGANDO</strong>
                        </div>
                      </div>
                    </Col>
                  </>
                ) : (
                  <>
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <S.EstiloColunasEstreitas />
                        <thead>
                          <tr>
                            {/*
                              `style` sobrepoe o min-width das classes globais th-xl (350px)
                              e th-grande (150px), que sao compartilhadas com outras tabelas.
                            */}
                            {/*
                              A miniatura come 44px do espaco do nome, mas alargar esta
                              coluna nao e de graca: a 1366px a tabela ja esta no limite e
                              cada pixel aqui vira rolagem horizontal. Preferido deixar o
                              nome quebrar em duas linhas.
                            */}
                            <th className="th-xl" style={{ minWidth: '176px', width: '16%' }}>Aluno(a)</th>
                            <th className="th-xl" style={{ minWidth: '160px', width: '22%' }}>Tema</th>
                            <th className="th-grande" style={{ minWidth: '112px', width: '13%' }}>Corretor</th>
                            <th className="th-grande" style={{ minWidth: '95px', width: '10%' }}>Turma</th>
                            {/*
                              Daqui para a direita as colunas usam a classe
                              `coluna-estreita`, que reduz o respiro lateral. Sem
                              isso as duas datas separadas não cabem a 1366px:
                              cada uma precisa de ~112px só para "26/09/2026", e
                              a tabela passava a exigir 74px de rolagem.
                            */}
                            <th className="th-grande coluna-estreita" style={{ minWidth: '66px', width: '6%' }}>Aula</th>
                            <th className="th-grande coluna-estreita" style={{ minWidth: '92px', width: '9%' }}>Enviada</th>
                            <th className="th-grande coluna-estreita" style={{ minWidth: '92px', width: '9%' }}>Corrigida</th>
                            <th className="th-grande coluna-estreita" style={{ minWidth: '85px', width: '8%' }}>Status</th>
                            <th className="th-grande coluna-acao" style={{ minWidth: '136px', width: '10%' }}>Ação</th>
                          </tr>
                        </thead>
                        <tbody>
                          {redacoes.map((redacao, idx) => (
                            <tr key={redacao.id_redacao || idx}>
                              <td>
                                <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                  <MiniaturaFoto foto={redacao.aluno_foto} nome={redacao.aluno} />
                                  <span>{redacao.aluno}</span>
                                </div>
                              </td>
                              <td>{redacao.tema}</td>
                              <td>{redacao.corretor}</td>
                              <td>{redacao.turma}</td>
                              <td className="coluna-estreita">{redacao.aulaBonus}</td>
                              <td className="coluna-estreita" style={{ whiteSpace: 'nowrap' }}>
                                {redacao.data
                                  ? new Date(redacao.data).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
                                  : 'N/A'}
                              </td>
                              <td className="coluna-estreita" style={{ whiteSpace: 'nowrap' }}>
                                {/*
                                  dataBR e não `new Date`: a data da correção vem
                                  como "AAAA-MM-DD" e passar por Date mostraria o
                                  dia anterior no nosso fuso.
                                */}
                                {redacao.data_correcao ? (
                                  dataBR(redacao.data_correcao)
                                ) : (
                                  <span className="text-muted">—</span>
                                )}
                              </td>
                              <td className="coluna-estreita">
                                {/*
                                  `badge-pill` deixa o raio em 10rem (totalmente arredondado);
                                  o inline sobrepõe para os 12px. O `whiteSpace: normal` é
                                  necessário porque o badge do BS4 é nowrap e o texto longo
                                  alargaria a coluna.
                                */}
                                {redacao.status === 'corrigido' && <span className="badge badge-pill badge-success" style={{ borderRadius: '12px' }}>Corrigida</span>}
                                {redacao.status === 'pendente_correcao' && <span className="badge badge-pill badge-warning" style={{ borderRadius: '12px' }}>Pendente</span>}
                                {/* já tem corretor trabalhando nela; a coluna Corretor mostra quem */}
                                {redacao.status === 'em_correcao' && <span className="badge badge-pill badge-info" style={{ borderRadius: '12px', whiteSpace: 'normal' }}>Em correção</span>}
                                {redacao.status === 'envio_pendente_aluno' && <span className="badge badge-pill badge-primary" style={{ borderRadius: '12px', whiteSpace: 'normal' }}>Envio Pendente do Aluno</span>}
                              </td>
                              <td className="coluna-acao">
                                {redacao.status === 'corrigido' && (
                                  <Link to={destinoCorrecao(redacao.id_redacao)} className="btn btn-sm btn-warning" style={{ whiteSpace: 'nowrap' }}>Editar Correção</Link>
                                )}
                                {redacao.status === 'pendente_correcao' && (
                                  <Link to={destinoCorrecao(redacao.id_redacao)} className="btn btn-sm btn-danger" style={{ whiteSpace: 'nowrap' }}>Fazer Correção</Link>
                                )}
                                {/*
                                  Correção começada e não terminada: sem este botão a
                                  linha ficava sem ação nenhuma, e quem parou no meio
                                  não tinha como voltar à redação.
                                */}
                                {redacao.status === 'em_correcao' && (
                                  <Link
                                    to={destinoCorrecao(redacao.id_redacao)}
                                    className="btn btn-sm btn-info"
                                    style={{ whiteSpace: 'nowrap' }}
                                    title={`Correção iniciada por ${redacao.corretor}`}
                                  >
                                    Continuar Correção
                                  </Link>
                                )}
                                {redacao.status === 'envio_pendente_aluno' && (
                                  <span className="badge badge-pill badge-indo" style={{ whiteSpace: 'normal' }}>Aguardando Aluno</span>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Controles de Paginação */}
                    {totalItens > 0 && totalPaginas > 1 && (
                      <div className="d-flex justify-content-between align-items-center mt-4 p-3 bg-light rounded">
                        <div className="d-flex align-items-center">
                          <span className="text-muted mr-3">
                            <strong>Página {paginaAtual} de {totalPaginas}</strong>
                          </span>
                          <span className="text-muted">
                            ({(paginaAtual - 1) * itensPorPagina + 1}-{Math.min(paginaAtual * itensPorPagina, totalItens)} de {totalItens} redações)
                          </span>
                        </div>
                        
                        <div className="d-flex align-items-center">
                          {/* Botão Primeira Página */}
                          <button
                            className="btn btn-outline-primary btn-sm mr-1"
                            onClick={() => irParaPagina(1)}
                            disabled={paginaAtual === 1}
                          >
                            <i className="fas fa-angle-double-left"></i>
                          </button>
                          
                          {/* Botão Página Anterior */}
                          <button
                            className="btn btn-outline-primary btn-sm mr-2"
                            onClick={paginaAnterior}
                            disabled={paginaAtual === 1}
                          >
                            <i className="fas fa-angle-left mr-1"></i>
                            Anterior
                          </button>

                          {/* Números das Páginas */}
                          <div className="d-flex">
                            {Array.from({ length: Math.min(5, totalPaginas) }, (_, i) => {
                              let pageNum;
                              if (totalPaginas <= 5) {
                                pageNum = i + 1;
                              } else if (paginaAtual <= 3) {
                                pageNum = i + 1;
                              } else if (paginaAtual >= totalPaginas - 2) {
                                pageNum = totalPaginas - 4 + i;
                              } else {
                                pageNum = paginaAtual - 2 + i;
                              }
                              
                              return (
                                <button
                                  key={pageNum}
                                  className={`btn btn-sm mr-1 ${
                                    pageNum === paginaAtual 
                                      ? 'btn-primary' 
                                      : 'btn-outline-primary'
                                  }`}
                                  onClick={() => irParaPagina(pageNum)}
                                >
                                  {pageNum}
                                </button>
                              );
                            })}
                          </div>

                          {/* Botão Próxima Página */}
                          <button
                            className="btn btn-outline-primary btn-sm ml-2"
                            onClick={proximaPagina}
                            disabled={paginaAtual === totalPaginas}
                          >
                            Próxima
                            <i className="fas fa-angle-right ml-1"></i>
                          </button>
                          
                          {/* Botão Última Página */}
                          <button
                            className="btn btn-outline-primary btn-sm ml-1"
                            onClick={() => irParaPagina(totalPaginas)}
                            disabled={paginaAtual === totalPaginas}
                          >
                            <i className="fas fa-angle-double-right"></i>
                          </button>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </S.MainContent>
            </Col>
          </Row>
        </Container>
      </S.MainWrapper>
    </Template>
  );
}

export default Redacoes;
